/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./squad.vue?vue&type=template&id=ff263202&scoped=true"
import script from "./squad.vue?vue&type=script&lang=js"
export * from "./squad.vue?vue&type=script&lang=js"
import style0 from "./squad.vue?vue&type=style&index=0&id=ff263202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff263202",
  null
  
)

export default component.exports